import {
  PartialVehicle,
  MakeModelAutocompleteOption,
  Vehicle,
  LicensePlate,
  VRImage,
  SaveAndScanResponseBody,
} from "types";
import { getRequestHeaders, handleRes } from "utils";
import AuthService from "utils/AuthService";

export interface GetVehicleSearchResponse extends Response {
  options?: Array<MakeModelAutocompleteOption>;
}

export interface GetVehicleResponse extends Response {
  vehicle?: Vehicle;
}

export const makeModelAutocomplete = async (
  make: string,
  model: string,
): Promise<GetVehicleSearchResponse> => {
  const query = new URLSearchParams({ make, model });
  return await fetch(`${window.VEHICLE_BASE_URL}/autocomplete?${query}`, {
    method: "GET",
    ...getRequestHeaders(),
  });
};

export const lookupVIN = async (vin: string): Promise<GetVehicleResponse> => {
  return await fetch(`${window.VEHICLE_BASE_URL}/vin-lookup/${vin}`, {
    method: "GET",
    ...getRequestHeaders(),
  });
};

export const lookupPlate = async (
  plate: LicensePlate,
): Promise<GetVehicleSearchResponse> => {
  return await fetch(
    `${window.VEHICLE_BASE_URL}/license-plate-lookup/${plate.state}/${plate.number}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  );
};

export const createVehicle = async (
  vehicle: PartialVehicle,
): Promise<GetVehicleResponse> => {
  // back end expects a numeric year
  const numericYear = vehicle.year ? parseInt(`${vehicle.year}`, 10) : 0;
  return await fetch(`${window.VEHICLE_BASE_URL}/vehicle`, {
    method: "POST",
    ...getRequestHeaders(),
    body: JSON.stringify({ ...vehicle, year: numericYear }),
  });
};

export const updateVehicle = async (
  vehicle: PartialVehicle,
): Promise<Response> => {
  // backed expects a numeric year
  const numericYear = vehicle.year ? parseInt(`${vehicle.year}`, 10) : 0;
  return await fetch(`${window.VEHICLE_BASE_URL}/vehicle/${vehicle.id}`, {
    method: "PUT",
    ...getRequestHeaders(),
    body: JSON.stringify({ ...vehicle, year: numericYear }),
  });
};

export const getVehicleByID = async (
  id: string,
): Promise<GetVehicleResponse> => {
  return await fetch(`${window.VEHICLE_BASE_URL}/vehicle/${id}`, {
    method: "GET",
    ...getRequestHeaders(),
  });
};

export const getVehicleByVIN = async (
  vin: string,
): Promise<GetVehicleResponse> => {
  return await fetch(`${window.VEHICLE_BASE_URL}/vehicle/vin/${vin}`, {
    method: "GET",
    ...getRequestHeaders(),
  });
};

export const saveAndScan = (
  vrImage: VRImage,
): Promise<SaveAndScanResponseBody> => {
  return fetch(`${window.VEHICLE_BASE_URL}/vehicle/image-recognition-upload`, {
    method: "POST",
    headers: {
      "Content-Type": "image/jpeg",
      Accept: "application/json",
      Authorization: `Bearer ${AuthService.GetToken()}`,
    },
    body: JSON.stringify(vrImage),
  })
    .then((res) => handleRes<SaveAndScanResponseBody>(res, 200))
    .catch((e) => {
      throw e;
    });
};
